// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"433":"843e2111","464":"33b230d2","631":"89dd9aaa","637":"630218cb","737":"9798bf93","768":"c0b0a7de"}[chunkId] + ".chunk.js";
};